import { render, staticRenderFns } from "./FeatureItem.vue?vue&type=template&id=318a82a0&"
import script from "./FeatureItem.vue?vue&type=script&lang=js&"
export * from "./FeatureItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports